//# sourceMappingURL=maintenance_mode.mjs.map
/// <reference types="./maintenance_mode.d.mts" />
import * as $maintenance from "../../../data_types/data/maintenance.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../gleam_stdlib/gleam/order.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $assoc from "../../../tiamat/gleam/assoc.mjs";
import * as $timestamp_ from "../../../tiamat/gleam/time/timestamp_.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $maintenance_effects from "../../admin/effects/maintenance_mode.mjs";
import * as $maintenance_mode from "../../data/maintenance_mode.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList } from "../../gleam.mjs";

function organization_maintenance(store, organization) {
  return [
    store,
    $maintenance_effects.set(
      toList([
        [
          organization,
          new $maintenance.Complete(
            store.maintenance_mode.input_from,
            store.maintenance_mode.input_to,
          ),
        ],
      ]),
    ),
  ];
}

function freezing(store) {
  return [
    store,
    $maintenance_effects.freeze(
      store.maintenance_mode.input_from,
      store.maintenance_mode.input_to,
    ),
  ];
}

export function update(store, msg) {
  if (msg instanceof $msg.ApiDeletedMaintenance) {
    let org_id = msg.org_id;
    let _pipe = store.maintenance_mode.maintenances;
    let _pipe$1 = $assoc.remove_all(_pipe, org_id);
    let _pipe$2 = ((_capture) => {
      return $maintenance_mode.set_maintenances(
        store.maintenance_mode,
        _capture,
      );
    })(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $store.set_maintenance_mode(store, _capture);
    })(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedFrozen) {
    let frozen = msg.frozen;
    let _pipe = frozen;
    let _pipe$1 = ((_capture) => {
      return $maintenance_mode.set_frozen(store.maintenance_mode, _capture);
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $store.set_maintenance_mode(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedMaintenances) {
    let maintenances = msg.maintenances;
    let _pipe = $maintenance_mode.set_maintenances(
      store.maintenance_mode,
      (() => {
        let initial = store.maintenance_mode.maintenances;
        return $assoc.fold(
          maintenances,
          initial,
          (acc, val) => { return $assoc.set(acc, val[0], val[1]); },
        );
      })(),
    );
    let _pipe$1 = ((_capture) => {
      return $store.set_maintenance_mode(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserClickedAddDuration) {
    let duration = msg.duration;
    let _pipe = store.maintenance_mode.input_to;
    let _pipe$1 = $timestamp.add(_pipe, duration);
    let _pipe$2 = ((_capture) => {
      return $maintenance_mode.set_to_input(store.maintenance_mode, _capture);
    })(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $store.set_maintenance_mode(store, _capture);
    })(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.UserEditedFromInput) {
    let from = msg.from;
    let $ = $timestamp_.from_datetime_local(from);
    if ($ instanceof Ok) {
      let from$1 = $[0];
      let _pipe = store.maintenance_mode;
      let _block;
      let $1 = $timestamp.compare(from$1, store.maintenance_mode.input_to);
      if ($1 instanceof $order.Lt) {
        _block = $function.identity;
      } else if ($1 instanceof $order.Eq) {
        _block = $function.identity;
      } else {
        _block = (_capture) => {
          return $maintenance_mode.set_to_input(_capture, from$1);
        };
      }
      let _pipe$1 = _block(_pipe);
      let _pipe$2 = $maintenance_mode.set_from_input(_pipe$1, from$1);
      let _pipe$3 = ((_capture) => {
        return $store.set_maintenance_mode(store, _capture);
      })(_pipe$2);
      return $pair.new$(_pipe$3, $effect.none());
    } else {
      return [store, $effect.none()];
    }
  } else if (msg instanceof $msg.UserEditedOrganizationInput) {
    let organization = msg.organization;
    let organization$1 = new Some(organization);
    let _pipe = store.maintenance_mode;
    let _pipe$1 = $maintenance_mode.set_organization_input(
      _pipe,
      organization$1,
    );
    let _pipe$2 = ((_capture) => {
      return $store.set_maintenance_mode(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserEditedToInput) {
    let to = msg.to;
    let $ = $timestamp_.from_datetime_local(to);
    if ($ instanceof Ok) {
      let to$1 = $[0];
      let _pipe = store.maintenance_mode;
      let _pipe$1 = $maintenance_mode.set_to_input(_pipe, to$1);
      let _pipe$2 = ((_capture) => {
        return $store.set_maintenance_mode(store, _capture);
      })(_pipe$1);
      return $pair.new$(_pipe$2, $effect.none());
    } else {
      return [store, $effect.none()];
    }
  } else if (msg instanceof $msg.UserResumedMaintenance) {
    let org_id = msg.org_id;
    return [
      store,
      (() => {
        if (org_id === "all") {
          return $maintenance_effects.unfreeze();
        } else {
          let org_id$1 = org_id;
          return $maintenance_effects.delete$(org_id$1);
        }
      })(),
    ];
  } else if (msg instanceof $msg.UserSubmittedMaintenance) {
    let $ = store.maintenance_mode.input_organization;
    if ($ instanceof Some) {
      let $1 = $[0];
      if ($1 === "all") {
        return freezing(store);
      } else {
        let organization = $1;
        return organization_maintenance(store, organization);
      }
    } else {
      return [store, $effect.none()];
    }
  } else {
    let toggled = msg.toggled;
    let _pipe = store.maintenance_mode;
    let _pipe$1 = $maintenance_mode.set_organization_input(
      _pipe,
      (() => {
        if (toggled) {
          return new Some("all");
        } else {
          return new None();
        }
      })(),
    );
    let _pipe$2 = ((_capture) => {
      return $store.set_maintenance_mode(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  }
}
